import React from 'react'
import TextRow from '../Rows/TextRow'
import { Shadow } from '../../types/Shadow.types'
import { FormTabProps } from '../../types/FormTab.types'

const EthernetConfigurationSection = ({ formState, handleChangeByShadow }: FormTabProps) => {
    const inputChanged = handleChangeByShadow(Shadow.Connman);

    return (
        <>
            <TextRow
                label="Adres IPv4"
                caption="IPv4_address"
                name="connman.IPv4_address"
                value={formState.connman.IPv4_address}
                onChange={inputChanged}
            />

            <TextRow
                label="Adres IPv6"
                caption="IPv6_address"
                name="connman.IPv6_address"
                value={formState.connman.IPv6_address}
                onChange={inputChanged}
            />

            <TextRow
                label="Klon adresu MAC"
                caption="MAC"
                name="connman.MAC"
                value={formState.connman.MAC}
                onChange={inputChanged}
            />

            <TextRow
                label="Ustawienie serwerów DNS"
                caption="Nameservers"
                name="connman.Nameservers"
                value={formState.connman.Nameservers}
                onChange={inputChanged}
            />

            <TextRow
                label="Ustawienie domen wyszukiwania"
                caption="SearchDomains"
                name="connman.SearchDomains"
                value={formState.connman.SearchDomains}
                onChange={inputChanged}
            />

        </>
    )
}

export default EthernetConfigurationSection